import Column from '@components/Column';
import Divider from '@components/Divider';
import Text from '@components/Text';
import colors from '@constants/colors';
import dayjs from 'dayjs';

import styles from './styles.module.scss';

interface Props {
    title: string;
    startAt: Date;
    endAt: Date;
}

function NoticeHeader({ title, startAt, endAt }:Props) {
    return (
        <Column as='section' className={styles.container}
            fullWidth
            spacing={16}>
            <Text size='2xl' fontWeight='bold' className={styles.title}>
                {title}
            </Text>
            <Text color={colors.gray6}>
                {dayjs(startAt).format('YYYY.MM.DD')}-{dayjs(endAt).format('YYYY.MM.DD')}
            </Text>
            <Divider isThin />
        </Column>
    );
}

export default NoticeHeader;
